export const FIREBASE_COMPANIES_TABLE = "companies";
export const FIREBASE_PROJECTS_TABLE = "projects";
export const FIREBASE_INACTIVE_USER_PROJECTS_TABLE = "deactivatedProjectsForUser";
export const FIREBASE_USERS_TABLE = "users";
export const FIREBASE_HOURS_TABLE = "hours";